import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import { type Theme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import LinkButton from '../../../ui/Button/LinkButton';

const useStyles = makeStyles((theme: Theme) => ({
  paperWrapper: {
    // No palette token matches this amber; kept in sync with DynamicAlertBanner's yellow banner.
    backgroundColor: '#ffbc2c',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down(400)]: {
      paddingTop: theme.spacing(1.25),
    },
  },
}));

type Props = MappedState;

const AlertPayoutFailed = (props: Props) => {
  const { currentApp } = props;
  const classes = useStyles();

  const link = `/${currentApp.AppId}/finance/bank-accounts`;

  return (
    <Grid container alignItems="center" className={classes.paperWrapper}>
      <Grid item xs={12}>
        <Toolbar>
          <Typography variant="body2" color="textPrimary">
            <Translate id="A_payout_could_not_be_sent_to_your_bank_account" />
          </Typography>

          <div style={{ flexGrow: 1 }} />
          <Hidden smDown>
            <LinkButton
              variant="text"
              color="primary"
              to={link}
              type="button"
              fdKey="Review_bank_account"
              style={{ letterSpacing: '1.25px' }}
            >
              <Translate id="Review_bank_account" />
            </LinkButton>
          </Hidden>
        </Toolbar>
      </Grid>

      <Hidden smUp>
        <Grid item xs={12}>
          <Box ml={1} mr={2} mb={1}>
            <LinkButton
              variant="text"
              color="primary"
              to={link}
              type="button"
              fdKey="Review_bank_account"
              style={{ letterSpacing: '1.25px' }}
            >
              <Translate id="Review_bank_account" />
            </LinkButton>
          </Box>
        </Grid>
      </Hidden>
    </Grid>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  currentApp: state.currentApp,
});

export default compose<MappedState, Record<string, never>>(connect(mapStateToProps, {}))(
  AlertPayoutFailed
);
